import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ICommissionList } from "../../../../auth/models/commission-interface";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { locale as italian } from "../../../../i18n/it";
import { ICustomer } from "../../customer.interface";
import { CustomerService } from "../../customer.service";

@Component({
  selector: "app-stats",
  templateUrl: "./stats.component.html",
  styleUrls: ["./stats.component.scss"],
})
export class StatsComponent implements OnInit {
  public contentHeader: IContentHeader;
  public searchKey: string = "";
  public tableLimit: number = 10;
  public list: Array<ICommissionList> = [];
  public filterList: Array<ICommissionList> = [];
  public filter_customer: number = 0;
  public customers_list: Array<ICustomer> = [];
  public totalRevenue: number = 0;
  public totalCost: number = 0;

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _userService: UserService,
    private router: Router,
    private _customerService: CustomerService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.STATS_CLIENT,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.PLATFORM_MANAGEMENT,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.STATS_CLIENT,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_customer_stats")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.customers_list = await this._customerService.getCustomers();
    this.customers_list = this.customers_list.sort((a, b) => (a.name > b.name ? 1 : -1));
    await this.loadCommissions();
    await this.searchCommission();
    this._utilService.hideLoading();
  }

  async loadCommissions() {
    this.list = await this._customerService.getCustomersCommissionAnalytics();
  }

  async searchCommission() {
    this.totalRevenue = 0;
    this.totalCost = 0;
    const key: string = this.searchKey.trim().toLowerCase();
    let filterList: Array<ICommissionList> = this.list;
    if (key.length > 0) {
      filterList = filterList.filter((item: ICommissionList) => item.client?.name?.toLowerCase().trim().includes(key));
    }
    if (this.filter_customer > 0) {
      filterList = filterList.filter((item: ICommissionList) => item.client?.id === this.filter_customer);
    }

    filterList = filterList.map((item: any) => {
      if (!item.analytics) {
        item.analytics = {
          employees: item.general_analytics.employees,
          estimate_cost: item.general_analytics.general_estimate_cost,
          estimate_profit: item.general_analytics.general_estimate_profit,
          margin_currency: item.general_analytics.general_margin_currency,
          margin_percentage: item.general_analytics.general_margin_percentage,
          real_cost: item.general_analytics.general_real_cost,
          real_profit: item.general_analytics.general_real_profit,
          products: item.general_analytics.products,
        };
        delete item.general_analytics;
      }
      return item;
    });

    if (filterList && filterList.length > 0) {
      filterList.map((item: any) => {
        if (!!item.analytics?.real_cost && item.analytics?.real_cost > 0) {
          this.totalCost += item.analytics?.real_cost || 0;
        }
        if (!!item.analytics?.real_profit && item.analytics?.real_profit > 0) {
          this.totalRevenue += item.analytics.real_profit;
        }
      });
    }

    this.filterList = filterList;
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }
}
